import React, { useEffect, useRef, useMemo } from 'react';
import styles from './css/index.module.css';

import { ChevronDown20Regular, Dismiss16Regular } from '@fluentui/react-icons';
import { PostFolderDocuments, startUploadBatch, updateUploadTrayItem } from '../../redux/documentsSlice';
import { GetDataroomItemInfo, setIRLItems } from '../../redux/dataroomSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineClose } from 'react-icons/ai';
import { validExtensions } from '../../utils/misc';
import { toast } from 'react-toastify';
import { isRagIndexableFileName, makeUploadClientId } from '../../utils/vdrUploadUtils';

const FOLDER_UPLOAD_BATCH_SIZE = 50;

const AddFolderDocModal = ({ setUploadFolderSidebar, setShowSidebar, /*selectedFolders*/ workstream }) => {
    // const selectedFolder = useMemo(() => {
    //     return selectedFolders?.length > 0 ? selectedFolders[selectedFolders.length - 1] : {};
    // }, [selectedFolders]);
    const [uploadedFiles, setUploadedFiles] = React.useState([]);
    const fileInputRef = useRef();
    const [folderDirectory, setFolderDirectory] = React.useState('');
    const { selectedProject } = useSelector(state => state?.projectData);
    const { items } = useSelector(state => state?.dataroom);
    const dispatch = useDispatch();
    const handleDivClick = () => {
        fileInputRef.current.click();
    };
    const handleFileChange = e => {
        const selectedFiles = Array.from(e.target.files);
        const nonEmptyFiles = selectedFiles.filter(file => file.size > 0); // Filter out zero-byte files

        if (nonEmptyFiles.length > 0) {
            setFolderDirectory(nonEmptyFiles[0].webkitRelativePath.split('/')[0]);
            setUploadedFiles(nonEmptyFiles);
        }
    };
    const handleDrop = e => {
        e.preventDefault();
        // const items = e.dataTransfer.items;
        // const allFiles = [];
        // const traverseDirectory = directory => {
        //     const reader = directory.createReader();
        //     reader.readEntries(entries => {
        //         let remainingEntries = entries.length;
        //         entries.forEach(entry => {
        //             if (entry.isFile) {
        //                 // Handle file
        //                 allFiles.push(entry);
        //             } else if (entry.isDirectory) {
        //                 // Handle nested directory
        //                 traverseDirectory(entry); // Recursive call to fetch files in nested directory
        //             }
        //             remainingEntries--;
        //             if (remainingEntries === 0) {
        //                 setUploadedFiles(Array.from(allFiles));
        //             }
        //         });
        //     });
        // };

        // for (let i = 0; i < items.length; i++) {
        //     const item = items[i].webkitGetAsEntry();
        //     if (item.isFile) {
        //         // Handle file
        //         allFiles.push(item);
        //     } else if (item.isDirectory) {
        //         // Handle directory
        //         setFolderDirectory(item?.name);
        //         traverseDirectory(item);
        //     }
        // }
    };
    const handlePaste = e => {
        const items = e.clipboardData.items;
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if (item.kind === 'file') {
                // const file = item.getAsFile();
                // Handle the pasted file as needed
                // console.log(file);
            }
        }
    };
    const handleClose = () => {
        setUploadedFiles([]);
        setShowSidebar(false);
        setUploadFolderSidebar(false);
        setFolderDirectory('');
    };
    const applyBatchUploadResults = (batchEntries, docs) => {
        const byName = {};
        (docs || []).forEach(doc => {
            const key = doc?.document_name;
            if (!key) return;
            if (!byName[key]) byName[key] = [];
            byName[key].push(doc);
        });

        batchEntries.forEach(entry => {
            const matchList = byName[entry.file.name] || [];
            const doc = matchList.shift();
            if (!doc?.id) {
                dispatch(
                    updateUploadTrayItem({
                        clientId: entry.clientId,
                        status: 'ready',
                    }),
                );
                return;
            }
            if (isRagIndexableFileName(entry.file.name)) {
                dispatch(
                    updateUploadTrayItem({
                        clientId: entry.clientId,
                        status: 'indexing',
                        documentId: Number(doc.id),
                        wsId: Number(workstream?.id),
                        startedAt: Date.now(),
                    }),
                );
            } else {
                dispatch(
                    updateUploadTrayItem({
                        clientId: entry.clientId,
                        status: 'ready',
                        documentId: Number(doc.id),
                        wsId: Number(workstream?.id),
                    }),
                );
            }
        });
    };

    const handleBulkFolderUpload = async uploadEntries => {
        let allRequestsSucceeded = true;
        const collectedFolders = [];

        for (let offset = 0; offset < uploadEntries.length; offset += FOLDER_UPLOAD_BATCH_SIZE) {
            const batchEntries = uploadEntries.slice(offset, offset + FOLDER_UPLOAD_BATCH_SIZE);
            const isLastBatch = offset + FOLDER_UPLOAD_BATCH_SIZE >= uploadEntries.length;

            batchEntries.forEach(entry => {
                dispatch(updateUploadTrayItem({ clientId: entry.clientId, status: 'uploading' }));
            });

            const formData = new FormData();
            batchEntries.forEach(entry => {
                formData.append('document', entry.file);
                formData.append('path', entry.folderPath);
                formData.append('document_name', entry.file.name);
                formData.append('project', selectedProject?.id);
                formData.append('vdr', selectedProject?.vdr?.id);
            });
            formData.append('trigger_indexer', isLastBatch ? 'true' : 'false');

            try {
                const res = await dispatch(PostFolderDocuments({ body: formData, ws_id: workstream?.id }));
                if (res?.type === 'POST_FOLDER_DOC/rejected') {
                    allRequestsSucceeded = false;
                    batchEntries.forEach(entry => {
                        dispatch(
                            updateUploadTrayItem({
                                clientId: entry.clientId,
                                status: 'failed',
                                error: 'Upload failed',
                            }),
                        );
                    });
                    continue;
                }

                const docs = Array.isArray(res?.payload) ? res.payload : [];
                collectedFolders.push(
                    ...docs.map(item => ({
                        name: item?.ws_folder,
                        id: item?.ws_folder_id,
                        parent: item?.parent_folder_id,
                        ws_id: res?.meta?.arg?.ws_id,
                        ws_name: item?.workstream,
                        prefix: item?.ws_folder_prefix,
                    })),
                );
                applyBatchUploadResults(batchEntries, docs);
            } catch (error) {
                allRequestsSucceeded = false;
                batchEntries.forEach(entry => {
                    dispatch(
                        updateUploadTrayItem({
                            clientId: entry.clientId,
                            status: 'failed',
                            error: 'Upload failed',
                        }),
                    );
                });
            }
        }

        if (collectedFolders.length) {
            function transformFolders(flatFolders) {
                const foldersMap = new Map();
                const nestedFolders = [];

                const uniqueFolders = flatFolders.reduce((acc, folder) => {
                    if (!foldersMap.has(folder?.id)) {
                        const folderCopy = { ...folder, children: [] };
                        foldersMap.set(folder?.id, folderCopy);
                        acc.push(folderCopy);
                    }
                    return acc;
                }, []);

                uniqueFolders.forEach(folder => {
                    const currentFolder = foldersMap.get(folder?.id);

                    if (folder?.parent === null) {
                        nestedFolders.push(currentFolder);
                    } else {
                        const parentFolder = foldersMap.get(folder.parent);
                        if (parentFolder) {
                            parentFolder.children.push(currentFolder);
                        }
                    }
                });

                return nestedFolders;
            }
            const nestedFolders = transformFolders(collectedFolders);
            dispatch(setIRLItems([...items, ...nestedFolders]));
        }

        return allRequestsSucceeded;
    };
    const handleAddFiles = () => {
        const files = uploadedFiles.filter(file => file.size > 0);

        if (files.length === 0) {
            toast.error('No valid files to upload');
            return;
        }

        const uploadEntries = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            if (file.name.startsWith('.')) continue;

            const fullPath = file.webkitRelativePath;
            const folderPath = fullPath.substring(0, fullPath.lastIndexOf('/'));

            uploadEntries.push({
                file,
                folderPath,
                clientId: makeUploadClientId(),
            });
        }

        if (!uploadEntries.length) {
            toast.error('No valid files to upload');
            return;
        }

        const trayItems = uploadEntries.map(entry => ({
            clientId: entry.clientId,
            fileName: entry.file.name,
            folderName: folderDirectory || '',
            status: 'queued',
        }));
        dispatch(
            startUploadBatch({
                destinationLabel: folderDirectory || 'Folder upload',
                items: trayItems,
            }),
        );

        handleBulkFolderUpload(uploadEntries).then(success => {
            if (success) {
                dispatch(GetDataroomItemInfo(workstream?.id));
                handleClose();
            }
        });
    };
    useEffect(() => {
        const div = document.getElementById('uploadDiv');
        if (div) {
            div.addEventListener('dragover', e => e.preventDefault());
            div.addEventListener('drop', handleDrop);
            div.addEventListener('paste', handlePaste);

            return () => {
                div.removeEventListener('dragover', e => e.preventDefault());
                div.removeEventListener('drop', handleDrop);
                div.removeEventListener('paste', handlePaste);
            };
        }
    }, []);
    return (
        <div className={styles.sidebarWhite}>
            <div className="d-flex align-items-center justify-content-between mb-5">
                <h5 className={styles.sidebarTitle}>Upload Folder in {workstream?.name} workstream</h5>
                <Dismiss16Regular onClick={handleClose} role="button" color="var(--Neutral-Gray-6)" />
            </div>
            {/* <div className="d-flex align-items-center">
                <span>{workstream?.name}</span>
                <ChevronDown20Regular className="ms-2" />
            </div> */}
            {folderDirectory ? (
                <div className={styles.uploadItemsList}>
                    <div className={styles.fileListItem}>
                        <span>{folderDirectory}</span>
                        <AiOutlineClose
                            size={14}
                            onClick={() => {
                                setFolderDirectory('');
                                setUploadedFiles([]);
                            }}
                        />
                    </div>
                </div>
            ) : (
                <div id="uploadDiv" className={styles.uploadBox} onClick={handleDivClick}>
                    <span>Click to Upload</span>
                    <input
                        multiple
                        type="file"
                        accept={validExtensions.join(',')}
                        webkitdirectory="true"
                        directory="true"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={handleFileChange}
                    />
                </div>
            )}

            <button onClick={handleAddFiles} className={styles.saveButton}>
                Save
            </button>
        </div>
    );
};
export default AddFolderDocModal;
